const eventIndexHtml = `
<section>
  <h4 class="c-headline-lv5 c-headline-lv5--line2--sp"><span>FC会員限定 <br class="u-hidden-min-md">事前抽選イベント</span></h4>
  <div class="c-eventcard-wrap">
    <a class="top-event-card is-purple" href="/special/thanks/event/selfie.html">
      <div class="top-event-card__header">選手と自撮り！<br>写真撮影会</div>
      <div class="top-event-card__body">CHECK</div>
    </a>
    <a class="top-event-card is-green" href="/special/thanks/event/autograph.html">
      <div class="top-event-card__header">写真撮影もできる！<br>サイン会</div>
      <div class="top-event-card__body">CHECK</div>
    </a>
    <a class="top-event-card is-yellow" href="/special/thanks/event/catchball.html">
      <div class="top-event-card__header">キャッチボール体験</div>
      <div class="top-event-card__body">CHECK</div>
    </a>
  </div>
</section>
<section>
  <h4 class="c-headline-lv5"><span>当日参加OK イベント</span></h4>
  <div class="c-eventcard-wrap">
    <a class="top-event-card is-purple" href="/special/thanks/event/highfive.html">
      <div class="top-event-card__header">ハイタッチ&<br>カイロ配布</div>
      <div class="top-event-card__body">CHECK</div>
    </a>
    <a class="top-event-card is-green" href="/special/thanks/event/base-running.html">
      <div class="top-event-card__header">ハイタッチ<br>ベースランニング</div>
      <div class="top-event-card__body">CHECK</div>
    </a>
    <a class="top-event-card is-yellow" href="/special/thanks/event/atti.html">
      <div class="top-event-card__header">あっち向いてホイ！</div>
      <div class="top-event-card__body">CHECK</div>
    </a>
    <a class="top-event-card is-yellow" href="/special/thanks/event/players.html">
      <div class="top-event-card__header">プレイヤーズロード</div>
      <div class="top-event-card__body">CHECK</div>
    </a>
  </div>
</section>
`;

function refreshScrollTrigger() {
  const run = () => {
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.refresh();
    }
  };

  run();
  requestAnimationFrame(run);
}

function replacePlaceholder(element, html) {
  element.insertAdjacentHTML('beforebegin', html);
  element.remove();
  refreshScrollTrigger();
}

export function mountEventIndex() {
  const eventIndex = document.getElementById('js-event-index');
  if (eventIndex) {
    replacePlaceholder(eventIndex, eventIndexHtml);
  }
}
